import styled from 'styled-components'
import { XImage } from './XImage'
import { Images } from '../../../utils/images'

export const BtcIcon = styled(XImage).attrs({
  src: Images.ICON.ICON_BTC_SVG,
})<{ size?: number; top?: number; right?: number; left?: number }>`
  width: ${(props) => props.size || 15}px;
  height: ${(props) => props.size || 15}px;
  position: relative;
  ${(props) => (props.top ? `top: ${props.top}px;` : '')};
  ${(props) => (props.right ? `margin-right: ${props.right}px;` : '')};
  ${(props) => (props.left ? `margin-left: ${props.left}px;` : '')};
`
